import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { fmtPKR, fmtDate } from "@/lib/format";

const enc = new TextEncoder();
const fmtNum = (v) => String(Number(v));

export async function verifyLayout(seed, layout) {
  const buf = await crypto.subtle.digest("SHA-256", enc.encode(`${seed}|${layout.map(fmtNum).join(",")}`));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
}

const DECISION = { deal: "DEAL", keep: "No Deal · kept box", swap: "No Deal · swapped" };

const Row = ({ g }) => {
  const [v, setV] = useState(null);
  const verify = async () => setV((await verifyLayout(g.server_seed, g.layout)) === g.commit_hash ? "ok" : "fail");
  return (
    <div className="py-4 text-sm" data-testid={`dnd-hist-${g.game_no}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <p className="text-white font-semibold">Game #{g.game_no} · {fmtPKR(g.amount)}</p>
          <p className="text-xs text-gray-500 keep-ltr">ID {g.id.slice(0, 8)} · {fmtDate(g.created_at)}</p>
        </div>
        <div className="text-end">
          <p className={g.status === "completed" ? "text-emerald-400 font-bold" : "text-yellow-500 font-bold"}>
            {g.status === "completed" ? `Final ${fmtPKR(g.payout)}` : "In progress"}
          </p>
          {g.status === "completed" && (
            <button onClick={verify} className="text-xs text-orange-400 inline-flex items-center gap-1" data-testid={`dnd-verify-${g.game_no}`}>
              <ShieldCheck className="w-3.5 h-3.5" />{v === "ok" ? "Verified" : v === "fail" ? "Mismatch" : "Verify"}
            </button>
          )}
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1 text-xs text-gray-500 mt-2">
        <p>Selected box: <span className="text-white">{g.own_box ?? "-"}</span>{g.final_box && g.final_box !== g.own_box ? <span className="text-white"> → {g.final_box}</span> : null}</p>
        <p>Decision: <span className="text-white">{DECISION[g.decision] || "-"}</span></p>
        <p className="sm:col-span-2">Opened ({g.opened_count}): <span className="text-white keep-ltr">{g.opened_boxes.map((o) => `#${o.box} ${fmtPKR(o.prize)}`).join(" · ") || "-"}</span></p>
        <p className="sm:col-span-2">Banker offers: <span className="text-white keep-ltr">{g.offers.map((o) => `${fmtPKR(o.amount)} (${o.decision === "deal" ? "DEAL" : "NO DEAL"})`).join(" · ") || "-"}</span></p>
        <p>Status: <span className="text-white capitalize">{g.status.replace("_", " ")}</span></p>
      </div>
    </div>
  );
};

export const DndHistory = ({ rows }) => (
  <div className="ec-card p-6" data-testid="dnd-history">
    <h3 className="font-head text-lg font-semibold text-white mb-2">My Deal or No Deal History</h3>
    {rows.length === 0 ? <p className="text-gray-500 text-sm py-8 text-center">No games played yet.</p> :
      <div className="divide-y divide-white/10 max-h-[32rem] overflow-y-auto">{rows.map((g) => <Row key={g.id} g={g} />)}</div>}
  </div>
);
